module.exports = __webpack_public_path__ + "static/img/commissionTho.0abea63.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/commissionTho.svg
// module id = tyGK
// module chunks = 4